module.exports = __webpack_public_path__ + "static/media/richmondHappyHour.5360be5b.pdf";